import { useRecordContext, NotFound } from "react-admin";
import { Box, Divider, MenuItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { doctoralRequests } from "api/doctoralApi";
import { DoctoralRankingStatus } from "utils/constants";
import DoctoralRankingResultsList from "./DoctoralRankingResultsList";
import DoctoralRankingSummary from "./DoctoralRankingSummary";
import DoctoralGenerateRankingButton from "components/Doctoral/DoctoralCampaigns/Show/DoctoralGenerateRankingButton";
import DoctoralApproveRankingButton from "components/Doctoral/DoctoralCampaigns/Show/DoctoralApproveRankingButton";
import DoctoralExportRankingButton from "components/Doctoral/DoctoralCampaigns/Show/DoctoralExportRankingButton";

const DoctoralRankingResults = () => {
  const record = useRecordContext();
  const [seatId, setSeatId] = useState("");

  if (!record) {
    return null;
  }

  if (record.status === DoctoralRankingStatus.Pending) {
    return <NotFound />;
  }

  const rankingUrl = doctoralRequests.campaignRanking(record.id);
  const seats = record.seatRankings ?? [];

  const seatLabel = seat =>
    seat.doctoralProgramNameBg
      ? `${seat.doctoralProgramNameBg}${seat.doctoralDisciplineNameBg ? ` — ${seat.doctoralDisciplineNameBg}` : ""}`
      : `Място ${seat.doctoralSeatId}`;

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="center" my={2} gap={3}>
        <Typography variant="h6" align="center" color={"secondary"}>
          Класиране <i>№{record?.rankingNumber}</i>
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent="center"
        alignItems={"center"}
        gap={2}
        flexDirection={record.status === DoctoralRankingStatus.Approved ? "column" : "row"}
      >
        {record.status === DoctoralRankingStatus.Draft ? (
          <>
            <DoctoralGenerateRankingButton />
            <DoctoralApproveRankingButton />
          </>
        ) : (
          <Typography variant="subtitle1" sx={{ fontStyle: "italic" }} align="center" color="secondary">
            Одобрено класиране
          </Typography>
        )}
        <DoctoralExportRankingButton />
      </Box>
      <Divider variant="middle" orientation="horizontal" sx={{ marginY: 2 }} />
      <Box display="flex" justifyContent="center">
        <TextField
          select
          label="Място"
          value={seatId}
          onChange={e => setSeatId(e.target.value)}
          sx={{ minWidth: 400 }}
        >
          {seats.map(seat => (
            <MenuItem key={seat.doctoralSeatId} value={seat.doctoralSeatId}>
              {seatLabel(seat)}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box my={3}>
        <Typography variant="inherit" align="center" color={"secondary"} component="div">
          {seatId
            ? `Резултати от класиране за място ${seatLabel(seats.find(s => s.doctoralSeatId === seatId) ?? {})}`
            : "Изберете място, за да видите резултатите от класирането."}
        </Typography>
      </Box>
      {seatId && (
        <>
          <Divider variant="middle" orientation="horizontal" sx={{ marginY: 2 }} />
          <DoctoralRankingSummary seatId={seatId} rankingUrl={rankingUrl} />
          <DoctoralRankingResultsList seatId={seatId} rankingUrl={rankingUrl} />
        </>
      )}
    </>
  );
};

export default DoctoralRankingResults;
